import { decodeToken, isExpired } from "react-jwt";

/**
 * 토큰 복호화
 */
export const getDecodeToken = (jwt?: string) => {
  const token = jwt || localStorage.getItem("tirepick_repairshop_access_token");

  return token
    ? decodeToken<{
        accountId: number;
        service: string;
        accountHistoryId: number;
        iat: number;
        exp: number;
        isMaster?: boolean;
        selectedRepairShop?: number;
      }>(token)
    : undefined;
};

/**
 * 토큰 만료여부
 * @returns
 */
export const expiredCheck = () => {
  const token = localStorage.getItem("tirepick_repairshop_access_token");

  return token ? isExpired(token) : undefined;
};
